import { useCallback, useMemo } from "react";
import { useForm } from "react-hook-form";
import useCreateUser from "../../modules/user/hooks/use-create-user";
import useUser from "../../modules/user/hooks/use-user";
import NextButton from "../next-button";
import './style.scss';

type Props = {}

const LoginForm: React.FC<Props> = () => {

    const { register, handleSubmit, formState } = useForm();
    const { createUser, error: apiError } = useCreateUser();
    const { libraryCode } = useUser();

    const onSubmit = useCallback((data) => {
        createUser(data.login, data.library);
    }, [createUser]);

    const error = useMemo(() => {

        if (formState.errors) {
            if (formState.errors['login']) {
                return 'Proszę wpisać poprawny login.'
            }

            if (formState.errors['library']) {
                return 'Proszę wpisać kod biblioteki.';
            }
        }

        if (apiError) {
            switch (apiError.code) {
                case 10100:
                    return 'Nieprawidłowy kod. Zdobądź kod w swojej lokalnej bibliotece.'
            }
        }

    }, [apiError, formState])

    return <>
        <form className="login-form" onSubmit={handleSubmit(onSubmit)}>
            <div className="page-box">
                <label className="page-box-content">
                    wpisz swoje imię/nick: <input type="text" placeholder="twój nick..." {...register('login', { required: true })} />
                </label>
            </div>
            <div className="page-box">
                <label className="page-box-content">
                    Podaj kod swojej biblioteki: <input type="text" placeholder="kod bibioteki..." defaultValue={libraryCode} {...register('library', { required: true })} />
                </label>
            </div>

            {error && <div className='page-box error-box'>
                <div className="page-box-content">
                    {error}
                </div>
            </div>
            }

            <div className="post-page-box-links">
                <NextButton>Dalej</NextButton>
            </div>
        </form>
    </>
}

export default LoginForm;
